/**
 * Contatto Titolare del trattamento (già "Informazioni DPO", v1.60 riscritta).
 *
 * IMPORTANTE (Reality Check Fase 0, feb-2026): il Titolare Christian e Ciro
 * Colucci S.a.s. NON ha attualmente nominato un DPO. La sezione §6-bis della
 * Privacy Policy è stata riscritta per riflettere questo fatto. Questa pagina
 * ora è un fallback informativo che spiega come esercitare i diritti GDPR
 * direttamente presso il Titolare, senza claim di DPO nominato.
 */
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Link } from "react-router-dom";
import { AlertCircle, Mail, ArrowLeft } from "lucide-react";

export default function DpoInfoPage() {
  return (
    <>
      <Header />
      <main className="pt-24 pb-16 bg-[#F5F1EA] min-h-screen">
        <div className="max-w-3xl mx-auto px-4">
          <Link to="/privacy" data-testid="dpo-back-to-privacy"
                 className="inline-flex items-center gap-2 text-sm text-[#163321] hover:underline mb-6">
            <ArrowLeft className="w-4 h-4" /> Torna alla Privacy Policy
          </Link>
          <div className="bg-white rounded-2xl shadow-sm border border-[#E5E2DB] p-6 sm:p-8"
                data-testid="dpo-info-fallback">
            <div className="flex items-start gap-3 mb-4">
              <AlertCircle className="w-6 h-6 text-amber-600 shrink-0 mt-0.5" />
              <h1 className="font-heading text-2xl sm:text-3xl text-[#0F1F14] font-semibold">
                Responsabile della Protezione dei Dati (DPO)
              </h1>
            </div>
            <p className="text-[15px] text-[#2E2E2E] leading-relaxed mb-4">
              Il Titolare del trattamento <strong>Christian e Ciro Colucci S.a.s.</strong> non
              ha attualmente designato un Responsabile della Protezione dei Dati (DPO).
              La designazione sarà valutata in base all&apos;evoluzione dei trattamenti gestiti,
              secondo i criteri previsti dall&apos;<strong>art. 37 del Regolamento (UE) 2016/679 (GDPR)</strong>.
            </p>
            <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-4 mb-4">
              <h2 className="font-heading text-base text-[#163321] font-semibold mb-2">
                Come esercitare i tuoi diritti GDPR
              </h2>
              <p className="text-[14px] text-[#2E2E2E] leading-relaxed mb-3">
                In assenza di un DPO nominato, tutte le richieste ai sensi degli
                <strong> artt. 15-22 GDPR</strong> (accesso, rettifica, cancellazione,
                limitazione, portabilità, opposizione, revoca del consenso) vanno
                indirizzate <strong>direttamente al Titolare</strong>:
              </p>
              <a href="mailto:colucci@colucciassicuratori.com"
                  data-testid="dpo-email-titolare"
                  className="inline-flex items-center gap-2 text-[15px] text-[#163321] font-semibold hover:underline">
                <Mail className="w-4 h-4" /> colucci@colucciassicuratori.com
              </a>
              <p className="text-[13px] text-[#4A5E51] mt-2">
                Il Titolare risponderà nei termini di legge: <strong>30 giorni</strong>,
                prorogabili di ulteriori <strong>60 giorni</strong> in casi complessi (art. 12 c.3 GDPR).
              </p>
            </div>
            <div className="bg-slate-50 border border-slate-200 rounded-xl p-4">
              <h3 className="font-heading text-sm text-[#0F1F14] font-semibold mb-2">
                Reclamo al Garante Privacy
              </h3>
              <p className="text-[13.5px] text-[#2E2E2E] leading-relaxed">
                Se ritieni che il trattamento dei tuoi dati violi il GDPR, puoi
                presentare reclamo all&apos;Autorità Garante per la Protezione dei Dati
                Personali: <a href="https://www.garanteprivacy.it"
                                target="_blank" rel="noopener noreferrer"
                                className="text-[#163321] underline">www.garanteprivacy.it</a>.
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
